/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstituteRoomBadge } from './InstituteRoomBadge';
import {
    InstituteRoomBadgeFromJSON,
    InstituteRoomBadgeFromJSONTyped,
    InstituteRoomBadgeToJSON,
    InstituteRoomBadgeToJSONTyped,
} from './InstituteRoomBadge';

/**
 * Response object for a waiting room.
 * @export
 * @interface WaitingRoomResponse
 */
export interface WaitingRoomResponse {
    /**
     * Unique identifier of the waiting room.
     * @type {string}
     * @memberof WaitingRoomResponse
     */
    roomId: string;
    /**
     * Description of the waiting room.
     * @type {string}
     * @memberof WaitingRoomResponse
     */
    name: string;
    /**
     * Street of the waiting room.
     * @type {string}
     * @memberof WaitingRoomResponse
     */
    street: string;
    /**
     * Indicates if this is the default waiting room.
     * @type {boolean}
     * @memberof WaitingRoomResponse
     */
    byDefault?: boolean;
    /**
     * Unique identifier of the institute address.
     * @type {string}
     * @memberof WaitingRoomResponse
     */
    addressId: string;
    /**
     * Unique identifier of the institute.
     * @type {string}
     * @memberof WaitingRoomResponse
     */
    instituteId: string;
    /**
     * 
     * @type {InstituteRoomBadge}
     * @memberof WaitingRoomResponse
     */
    roomBadge?: InstituteRoomBadge;
}

/**
 * Check if a given object implements the WaitingRoomResponse interface.
 */
export function instanceOfWaitingRoomResponse(value: object): value is WaitingRoomResponse {
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('addressId' in value) || value['addressId'] === undefined) return false;
    if (!('instituteId' in value) || value['instituteId'] === undefined) return false;
    return true;
}

export function WaitingRoomResponseFromJSON(json: any): WaitingRoomResponse {
    return WaitingRoomResponseFromJSONTyped(json, false);
}

export function WaitingRoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitingRoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'],
        'name': json['name'],
        'street': json['street'],
        'byDefault': json['byDefault'] == null ? undefined : json['byDefault'],
        'addressId': json['addressId'],
        'instituteId': json['instituteId'],
        'roomBadge': json['roomBadge'] == null ? undefined : InstituteRoomBadgeFromJSON(json['roomBadge']),
    };
}

export function WaitingRoomResponseToJSON(json: any): WaitingRoomResponse {
    return WaitingRoomResponseToJSONTyped(json, false);
}

export function WaitingRoomResponseToJSONTyped(value?: WaitingRoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'name': value['name'],
        'street': value['street'],
        'byDefault': value['byDefault'],
        'addressId': value['addressId'],
        'instituteId': value['instituteId'],
        'roomBadge': InstituteRoomBadgeToJSON(value['roomBadge']),
    };
}

